import { NGI_WIDGETS_IN_DESIGNER_FF_TOKEN } from '@lumapps/widget-base/constants';

(function IIFE() {
    'use strict';
    function WidgetImageGalleryController(Content, Features, Utils) {
        'ngInject';

        const vm = this;

        /////////////////////////////
        //                         //
        //    Public attributes    //
        //                         //
        /////////////////////////////

        /**
         * Services and utilities.
         */
        vm.Features = Features;

        /////////////////////////////
        //                         //
        //     Public functions    //
        //                         //
        /////////////////////////////

        /**
         * Get widget classes.
         *
         * @return {Array} An array of widget css classes.
         */
        function getWidgetClass() {
            const widgetClass = ['widget', 'widget-image-gallery'];

            vm.parentCtrl.getWidgetClass(widgetClass);

            if (vm.widget.properties.viewModeVariant === 'ungroup') {
                widgetClass.push('widget--view-mode-variant-ungroup');
            }
            return widgetClass;
        }

        vm.getWidgetClass = getWidgetClass;

        /**
         * Set parent controller.
         *
         * @param {Object} parentCtrl The parent controller.
         */
        this.setParentController = function setParentController(parentCtrl) {
            vm.parentCtrl = parentCtrl;
        };
    }

    /////////////////////////////

    function widgetImageGalleryDirective() {
        'ngInject';

        function link(scope, el, attrs, ctrls) {
            ctrls[0].setParentController(ctrls[1]);
        }

        return {
            bindToController: true,
            controller: WidgetImageGalleryController,
            controllerAs: 'vm',
            link,
            replace: true,
            require: ['widgetImageGallery', '^widget'],
            restrict: 'E',
            scope: {
                widget: '=',
            },
            // eslint-disable-next-line max-len
            templateUrl:
                '/client/front-office/modules/content/modules/widget/modules/widget-image-gallery/views/widget-image-gallery.html',
        };
    }

    /////////////////////////////

    window.angular.module('Widgets').directive('widgetImageGallery', widgetImageGalleryDirective);
})();

/////////////////////////////

// export { WidgetImageGalleryController, WidgetImageGalleryDirective };
